module.exports = __webpack_public_path__ + "static/media/Web-Based.405f993f.png";